import React, { Dispatch, SetStateAction, useState } from 'react';
import { Carousel } from 'react-bootstrap';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { CategoryDA } from '../../services/admin/category.service';
import { Error } from '../../models/error.model';
import { Company } from '../../models/company.model';
import { Category } from '../../models/category.model';
import { GlobalSwal } from '../../styles/swal.style';
import { Service } from '../../models/service.model';
import { Product } from '../../models/product.model';
import { imageProduct } from '../../scripts/image.value.script';
import { modalHide } from '../../utils/modal.util';
import { errorWebHandler } from '../../scripts/error.web.handler.script';

import AppLoading from '../Loading';
import imageSearch from '../../assets/themes/images/search.svg';
import EmptyState from '../element/EmptyState';
import imgServiceDefault from '../../assets/themes/service.png';
import imgProductDefault from '../../assets/themes/product.png';

export interface AppModalCategoryUpdateListingProps {
  companyForUser: Company | null,
  servicesForCompany: Service[] | null,
  productsForCompany: Product[] | null,
  category: Category | null,
  categoryServices: string[] | null,
  categoryProducts: string[] | null,
  setCategory: Dispatch<SetStateAction<Category | null>>,
  setCategoryServices: Dispatch<SetStateAction<string[] | null>>,
  setCategoryProducts: Dispatch<SetStateAction<string[] | null>>,
  loadServicesForCompany: Function,
  loadProductsForCompany: Function
};

let errorResponse: Error, categoryResponse: Category;

const AppModalCategoryUpdateListing: React.FunctionComponent<AppModalCategoryUpdateListingProps> = ({companyForUser, servicesForCompany, productsForCompany, category, categoryServices, categoryProducts, setCategory, setCategoryServices, setCategoryProducts, loadServicesForCompany, loadProductsForCompany}) => {
  const {lang} = StateLanguage()

  const [loadIndicator, setLoadIndicator] = useState('off')

  const submitCategoryUpdate = async () => {
    setLoadIndicator('on')

    if (companyForUser && category && categoryServices && categoryProducts) {
      await CategoryDA.putCategoryProducts(companyForUser.id, category.id, categoryServices, categoryProducts).then( (response) => {
        if (response.status === 200) {
          categoryResponse = response.data

          setCategory(categoryResponse)
          loadProductsForCompany(companyForUser.id)
          loadServicesForCompany(companyForUser.id)

          GlobalSwal.fire({
            title: lang.labels.successfullyUpdatedCategory,
            text: lang.labels.actionCompletedReturningToPage,
            icon: 'success',
            showConfirmButton: false,
            timer: 2200
          }).then( () => {
            executeHideModalCategoryUpdateListing()
          })
        } else {
          errorResponse = response.data

          GlobalSwal.fire({
            title: `${errorResponse.message}!`,
            text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
            icon: 'error',
            confirmButtonText: lang.labels.okGotIt
          })
        }
      }).catch( (error) => {
        errorWebHandler(lang, error)
      }).finally(() => {
        setLoadIndicator('off')
      })
    } else {
      GlobalSwal.fire({
        text: lang.labels.sorryLooksLikeThereAreSomeErrorsTrySolve,
        icon: 'error',
        showConfirmButton: false,
        timer: 2200
      }).then( () => {
        setLoadIndicator('off')
      })
    }
  }

  const handleChangeSelectItem = (item: string, event: React.ChangeEvent <HTMLFormElement | HTMLInputElement>) => {
    if (categoryServices && item === 'service') {
      let list: string[] = (event.target.checked) ? (!categoryServices.includes(event.target.value)) ? categoryServices.concat(event.target.value) : categoryServices : categoryServices.filter((other_item) => (other_item !== event.target.value))
      setCategoryServices(list)
    }
    if (categoryProducts && item === 'product') {
      let list: string[] = (event.target.checked) ? (!categoryProducts.includes(event.target.value)) ? categoryProducts.concat(event.target.value) : categoryProducts : categoryProducts.filter((other_item) => (other_item !== event.target.value))
      setCategoryProducts(list)
    }
  }

  const executeHideModalCategoryUpdateListing = () => {
    modalHide('modal-category-update-listing')

    setTimeout( () => {
      restartModal()
    }, 200 )
  }

  function restartModal() {
    setCategoryServices([])
    setCategoryProducts([])
  }

  return (
    <div id="modal-category-update-listing" className="modal fade" tabIndex={-1} aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="text-capitalize">{lang.labels.updateCategoryItemList}</h2>
          </div>
          <div className="modal-body">
            { productsForCompany && servicesForCompany && category && categoryServices && categoryProducts
              ?
              <>
                <div className="text-justify mb-5">
                  {lang.labels.checkOrUncheck}
                  { ((servicesForCompany.length === 0 && productsForCompany.length === 0) || (servicesForCompany.length > 0 && productsForCompany.length > 0)) &&
                    <span className="text-lowercase fw-bold mx-1">{lang.labels.services} {lang.labels.and} {lang.labels.products}</span>
                  }
                  { servicesForCompany.length > 0 && productsForCompany.length === 0 &&
                    <span className="text-lowercase fw-bold mx-1">{lang.labels.services}</span>
                  }
                  { servicesForCompany.length === 0 && productsForCompany.length > 0 &&
                    <span className="text-lowercase fw-bold mx-1">{lang.labels.products}</span>
                  }
                  {lang.labels.toAddOrRemoveCategory}
                  <strong className="ms-1">{category.display_name}</strong>
                  .
                </div>
                { servicesForCompany.length === 0 && productsForCompany.length === 0
                  ?
                  <EmptyState illustration={imageSearch} illustrationAlt="" title={lang.labels.noRecordsFound} description={lang.labels.startAddingNewElementsToThisCategory} size="sm" />
                  :
                  <div className={`row row-cols-1 ${servicesForCompany.length > 0 && productsForCompany.length > 0 && "row-cols-lg-2"}`}>
                    <div className="pe-lg-5 mb-5 mb-lg-0">
                      { servicesForCompany.length > 0 && productsForCompany.length > 0 &&
                        <>
                          <div className="fw-bold">{lang.labels.listServices}</div>
                          <div className="separator separator-dashed mb-2"></div>
                        </>
                      }
                      <div className="mh-500px hover-scroll-y">
                        { servicesForCompany.map (( (item, index) => { return (
                          <div key={index}>
                            <label className="d-flex flex-stack cursor-pointer mb-2">
                              <span className="d-flex align-items-center">
                                { item.photos.length > 0
                                  ?
                                  <Carousel slide={false} controls={false} indicators={false} touch={false}>
                                    { item.photos.map (( (item, index) => { return (
                                      <Carousel.Item key={index}>
                                        <img src={imageProduct(item)} className="d-block w-35px h-35px" alt={lang.labels.photography + index} />
                                      </Carousel.Item>
                                    )}))}
                                  </Carousel>
                                  :
                                  <span className="symbol symbol-35px">
                                    <span className="symbol-label">
                                      <img src={imgServiceDefault} alt={lang.labels.photography} className="w-100 h-100" />
                                    </span>
                                  </span>
                                }
                                <span className="fs-7 ms-2 me-3">{item.display_name}</span>
                              </span>
                              <span className="form-check form-check-custom form-check-solid me-2">
                                <input className="form-check-input" type="checkbox" value={item.id} checked={categoryServices.includes(item.id)} onChange={(event) => handleChangeSelectItem("service", event)} />
                              </span>
                            </label>
                          </div>
                        )}))}
                      </div>
                    </div>
                    <div className="ps-lg-5 mb-0">
                      { productsForCompany.length > 0 && servicesForCompany.length > 0 &&
                        <>
                          <div className="fw-bold">{lang.labels.listProducts}</div>
                          <div className="separator separator-dashed mb-2"></div>
                        </>
                      }
                      <div className="mh-500px hover-scroll-y">
                        { productsForCompany.map (( (item, index) => { return (
                          <div key={index}>
                            <label className="d-flex flex-stack cursor-pointer mb-2">
                              <span className="d-flex align-items-center">
                                { item.photos.length > 0
                                  ?
                                  <Carousel slide={false} controls={false} indicators={false} touch={false}>
                                    { item.photos.map (( (item, index) => { return (
                                      <Carousel.Item key={index}>
                                        <img src={imageProduct(item)} className="d-block w-35px h-35px" alt={lang.labels.photography + index} />
                                      </Carousel.Item>
                                    )}))}
                                  </Carousel>
                                  :
                                  <span className="symbol symbol-35px">
                                    <span className="symbol-label">
                                      <img src={imgProductDefault} alt={lang.labels.photography} className="w-100 h-100" />
                                    </span>
                                  </span>
                                }
                                <span className="fs-7 ms-2 me-3">{item.display_name}</span>
                              </span>
                              <span className="form-check form-check-custom form-check-solid me-2">
                                <input className="form-check-input" type="checkbox" value={item.id} checked={categoryProducts.includes(item.id)} onChange={(event) => handleChangeSelectItem("product", event)} />
                              </span>
                            </label>
                          </div>
                        )}))}
                      </div>
                    </div>
                  </div>
                }
              </>
              :
              <AppLoading></AppLoading>
            }
          </div>
          <div className="modal-footer flex-center">
            <button className="btn btn-secondary mx-2" type="reset" onClick={executeHideModalCategoryUpdateListing}>{lang.labels.discard}</button>
            <button className="btn btn-primary mx-2" type="button" data-kt-indicator={loadIndicator} onClick={submitCategoryUpdate}>
              <span className="indicator-label">{lang.labels.update}</span>
              <span className="indicator-progress">
                {lang.labels.pleaseWait}
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AppModalCategoryUpdateListing;
